/* BPL presentation only. Turbo owns selected IDs, radios, prices, cart and media. */
(() => {
  'use strict';

  if (window.BPLUniversalProduct) {
    window.BPLUniversalProduct.init(document);
    return;
  }

  const forms = new Map();
  const galleries = new Map();
  const reviewWidgets = new Map();
  const mainFormSelector = '.shopify-section--product-template [data-product-form]';
  const groupSelector = '[data-bpl-items]';
  const gallerySelector = '.bpl-product--01 .gallery-wrap';
  const reviewSelector = '.bpl-product--01 loox-snippets-widget';
  const reviewStyle = `
    .quickview-button .element {
      padding: 16px;
      font-size: calc(var(--loox-snippets-u-font-size, var(--lxs-font-size-s)) + 1px);
      line-height: 1.6;
    }
    .quickview-button .text {
      -webkit-line-clamp: 3;
      line-clamp: 3;
    }
    @media (max-width: 767px) {
      .quickview-button .element {
        font-size: var(--loox-snippets-u-font-size, var(--lxs-font-size-s));
      }
    }
  `;

  function productData(form) {
    try {
      const data = JSON.parse(form.getAttribute('data-product') || '{}');
      return Array.isArray(data.variants) ? data : { variants: [], options: [] };
    } catch (_) {
      return { variants: [], options: [] };
    }
  }

  function variantOptions(variant) {
    return variant.options || [variant.option1, variant.option2, variant.option3].filter(value => value != null);
  }

  function optionName(option) {
    return typeof option === 'string' ? option : (option && option.name) || '';
  }

  function displayOptionName(name) {
    return name.trim();
  }

  function selection(form, data, master) {
    const variant = data.variants.find(item => String(item.id) === master.value);
    if (variant) return { variant, values: variantOptions(variant) };
    // An impossible combination has no variant ID. Read what the native controls
    // display, without choosing a replacement or changing those controls.
    const selectors = Array.from(form.querySelectorAll('.single-option-selector'));
    const swatches = Array.from(form.querySelectorAll('.swatch[data-option-index]'));
    const values = (data.options || []).map((_, index) => {
      const swatch = swatches.find(item => Number(item.dataset.optionIndex) === index);
      const checked = swatch && swatch.querySelector('input[type="radio"]:checked');
      return (selectors[index] && selectors[index].value) || (checked && checked.value) || '';
    });
    return { variant: null, values };
  }

  function availability(data, selected, optionIndex, value) {
    const matches = data.variants.filter(variant => {
      const values = variantOptions(variant);
      return values[optionIndex] === value && selected.every((choice, index) =>
        index === optionIndex || !choice || values[index] === choice
      );
    });
    if (!matches.length) return 'Unavailable';
    return matches.some(variant => variant.available) ? '' : 'Sold out';
  }

  function writeText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function updateLabels(form, data, current) {
    if (!form.closest('.bpl-product--01')) return;
    form.querySelectorAll('[data-bpl-option-name]').forEach(swatch => {
      const index = Number(swatch.dataset.optionIndex);
      writeText(swatch.querySelector('[data-bpl-option-label]'), current.values[index] || '');
      swatch.querySelectorAll('[data-bpl-option-value]').forEach(element => {
        const status = availability(data, current.values, index, element.dataset.bplOptionValue);
        const statusElement = element.querySelector('[data-bpl-option-status]');
        writeText(statusElement, status);
        if (statusElement) statusElement.hidden = !status;
        element.classList.toggle('bpl-option-is-unavailable', Boolean(status));
        const label = element.querySelector('label');
        if (label) label.title = status ? `${element.dataset.bplOptionValue} — ${status}` : element.dataset.bplOptionValue;
        // Native availability and checked/disabled state are deliberately untouched.
      });
    });

    // Turbo creates these labels for its select-style form. Preserve label/for
    // associations and the merchant's option name. Swatch mode stays separate.
    if (!form.querySelector('[data-bpl-option-name]')) {
      const selectors = Array.from(form.querySelectorAll('.single-option-selector'));
      if (!selectors.length) {
        const master = form.querySelector('select[name="id"]');
        if (master && (data.options || []).length === 1 && optionName(data.options[0]) !== 'Title') selectors.push(master);
      }
      selectors.forEach((select, index) => {
        const wrapper = select.closest('.selector-wrapper, .select');
        const label = wrapper && wrapper.querySelector('label');
        const name = displayOptionName(optionName((data.options || [])[index]));
        if (label && name) writeText(label, name);
      });
    }
  }

  function updateGroups(productId, variantId) {
    document.querySelectorAll(groupSelector).forEach(container => {
      if (container.dataset.productId !== productId) return;
      const groups = Array.from(container.querySelectorAll('[data-bpl-items-group]'));
      const active = groups.find(group => group.dataset.variantId === variantId)
        || groups.find(group => group.dataset.variantId === 'default');
      groups.forEach(group => { group.hidden = group !== active; });
      const section = container.closest('[data-bpl-items-section]');
      if (section) {
        const copy = section.querySelector('[data-bpl-items-copy]');
        const hasCopy = Boolean(copy && copy.textContent.trim());
        const hasCards = Boolean(active && active.querySelector('[data-bpl-item-card]'));
        section.hidden = !hasCopy && !hasCards;
      }
    });
  }

  function sync(form) {
    const state = forms.get(form);
    if (!state || !form.isConnected) return;
    const master = form.querySelector('select[name="id"]');
    if (!master) return;
    const current = selection(form, state.data, master);
    updateLabels(form, state.data, current);
    updateGroups(form.dataset.productId, current.variant ? String(current.variant.id) : 'default');
    document.querySelectorAll('[data-bpl-items-color]').forEach(row => {
      if (row.dataset.productId !== form.dataset.productId) return;
      const color = current.values[Number(row.dataset.bplColorIndex)] || '';
      writeText(row.querySelector('[data-bpl-items-color-value]'), color);
      const section = row.closest('[data-bpl-items-section]');
      const activeCards = section && section.querySelector('[data-bpl-items-group]:not([hidden]) [data-bpl-item-card]');
      row.hidden = !color || !activeCards;
    });
  }

  function schedule(form) {
    const state = forms.get(form);
    if (!state || state.frame) return;
    // selectCallback dispatches before it finishes setting the visible radios.
    // One animation frame observes its final state; there is no polling loop.
    state.frame = window.requestAnimationFrame(() => {
      state.frame = 0;
      sync(form);
    });
  }

  function attach(form) {
    if (forms.has(form)) return schedule(form);
    const onChange = event => {
      if (event.target.matches('select[name="id"], .single-option-selector, .swatch input[type="radio"]')) schedule(form);
    };
    forms.set(form, { data: productData(form), onChange, frame: 0 });
    // Capture is essential: Turbo's native master-select event does not bubble.
    form.addEventListener('change', onChange, true);
    sync(form);
    schedule(form);
  }

  function remove(form) {
    const state = forms.get(form);
    if (!state) return;
    form.removeEventListener('change', state.onChange, true);
    if (state.frame) window.cancelAnimationFrame(state.frame);
    forms.delete(form);
  }

  function markThumbnail(state, thumbnail, current) {
    thumbnail.classList.toggle('bpl-thumbnail-is-current', current);
    if (current) {
      if (thumbnail.getAttribute('aria-current') !== 'true') {
        if (!state.aria.has(thumbnail)) state.aria.set(thumbnail, thumbnail.getAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
      }
    } else if (state.aria.has(thumbnail)) {
      // Restore only the attribute this observer wrote; leave later native writes alone.
      const previous = state.aria.get(thumbnail);
      if (thumbnail.getAttribute('aria-current') === 'true') {
        if (previous === null) thumbnail.removeAttribute('aria-current');
        else thumbnail.setAttribute('aria-current', previous);
      }
      state.aria.delete(thumbnail);
    }
  }

  function syncGallery(gallery) {
    const state = galleries.get(gallery);
    if (!state || !gallery.isConnected) return;
    const slides = Array.from(state.main.querySelectorAll('.gallery-cell'));
    const thumbnails = Array.from(state.nav.querySelectorAll('.product-gallery__thumbnail'));
    const selected = slides.filter(slide => slide.classList.contains('is-selected'));
    // Main and navigation media share their native order. Never guess a missing match.
    const index = slides.length && slides.length === thumbnails.length && selected.length === 1
      ? slides.indexOf(selected[0]) : -1;
    thumbnails.forEach((thumbnail, thumbnailIndex) => markThumbnail(state, thumbnail, thumbnailIndex === index));
  }

  function scheduleGallery(gallery) {
    const state = galleries.get(gallery);
    if (!state || state.frame) return;
    state.frame = window.requestAnimationFrame(() => {
      state.frame = 0;
      syncGallery(gallery);
    });
  }

  function attachGallery(gallery) {
    if (galleries.has(gallery)) return scheduleGallery(gallery);
    const main = gallery.querySelector('[data-product-gallery]');
    const nav = gallery.querySelector('.product_gallery_nav');
    if (!main || !nav) return;
    const observer = new MutationObserver(() => scheduleGallery(gallery));
    galleries.set(gallery, { main, nav, observer, frame: 0, aria: new Map() });
    // Observe native selection only. Thumbnail presentation writes cannot retrigger this.
    observer.observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    syncGallery(gallery);
    scheduleGallery(gallery);
  }

  function removeGallery(gallery) {
    const state = galleries.get(gallery);
    if (!state) return;
    state.observer.disconnect();
    if (state.frame) window.cancelAnimationFrame(state.frame);
    state.nav.querySelectorAll('.product-gallery__thumbnail').forEach(thumbnail => markThumbnail(state, thumbnail, false));
    state.aria.forEach((_, thumbnail) => markThumbnail(state, thumbnail, false));
    galleries.delete(gallery);
  }

  function removeReview(widget) {
    const state = reviewWidgets.get(widget);
    if (!state) return;
    if (state.timer) window.clearTimeout(state.timer);
    if (state.style) state.style.remove();
    reviewWidgets.delete(widget);
  }

  function attachReview(widget) {
    if (reviewWidgets.has(widget)) return;
    const state = { timer: 0, attempts: 0, style: null };
    reviewWidgets.set(widget, state);
    const apply = () => {
      if (reviewWidgets.get(widget) !== state) return;
      state.timer = 0;
      if (!widget.isConnected || !widget.matches(reviewSelector)) return removeReview(widget);
      const shadow = widget.shadowRoot;
      // Enhance only the known open-shadow layout. Closed or changed markup
      // retains Loox's ordinary presentation and all of its native behavior.
      if (shadow && shadow.querySelector('.quickview-button .element') && shadow.querySelector('.quickview-button .text')) {
        state.style = document.createElement('style');
        state.style.setAttribute('data-bpl-review-layout', '01');
        state.style.textContent = reviewStyle;
        shadow.appendChild(state.style);
        return;
      }
      // Component rendering may follow its upgrade. Wait at most ten seconds;
      // never poll indefinitely or observe the whole storefront document.
      state.attempts += 1;
      if (state.attempts < 40) state.timer = window.setTimeout(apply, 250);
    };
    if (window.customElements && !window.customElements.get('loox-snippets-widget')) {
      window.customElements.whenDefined('loox-snippets-widget').then(apply);
    } else {
      apply();
    }
  }

  function init(root) {
    reviewWidgets.forEach((_, widget) => { if (!widget.isConnected) removeReview(widget); });
    if (root.matches && root.matches(reviewSelector)) attachReview(root);
    root.querySelectorAll(reviewSelector).forEach(attachReview);
    forms.forEach((_, form) => { if (!form.isConnected) remove(form); });
    if (root.matches && root.matches(mainFormSelector)) attach(root);
    root.querySelectorAll(mainFormSelector).forEach(attach);
    // An included-items section can reload independently from the product form.
    forms.forEach((_, form) => schedule(form));
    galleries.forEach((_, gallery) => { if (!gallery.isConnected) removeGallery(gallery); });
    if (root.matches && root.matches(gallerySelector)) attachGallery(root);
    root.querySelectorAll(gallerySelector).forEach(attachGallery);
  }

  function unload(root) {
    reviewWidgets.forEach((_, widget) => { if (root === widget || root.contains(widget)) removeReview(widget); });
    forms.forEach((_, form) => { if (root === form || root.contains(form)) remove(form); });
    galleries.forEach((_, gallery) => { if (root === gallery || root.contains(gallery)) removeGallery(gallery); });
  }

  window.BPLUniversalProduct = { init, unload };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  window.addEventListener('load', () => init(document), { once: true });
})();
